<!-- Divider -->
<div
    class="vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
